import Vue from "vue";
import Vuex from "vuex";

import Crews from "./store-modules/module-crews";
import Projects from "./store-modules/module-projects";
import Contracts from "./store-modules/contracts/module-contracts";
import Contacts from "./store-modules/module-contacts";
import CreateEditViewLayout from "./store-modules/module-create-edit-view-layout";
import ConfirmationModal from "./store-modules/module-confirmation-modal";
import Modal from "./store-modules/module-modal";
import Dashboard from "./store-modules/module-dashboard";
import FeedbackToasts from "./store-modules/module-feedback-toasts";
import Items from "./store-modules/module-items";
import Users from "./store-modules/module-users";
import Settings from "./store-modules/module-settings";
import Search from "./store-modules/module-search";
import PDF from "./store-modules/module-pdf";
import Auth from "./store-modules/module-auth";
import { ApiResponseStatus, CalendarTypes } from "./constants/enums";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    CreateEditViewLayout,
    ConfirmationModal,
    Modal,
    Crews,
    Projects,
    Contracts,
    Contacts,
    Dashboard,
    FeedbackToasts,
    Items,
    Users,
    Settings,
    Search,
    PDF,
    Auth
  },
  state: {
    isMobileNavOpen: false,
    userName: window.localStorage.userName
      ? window.atob(window.localStorage.userName)
      : undefined,
    userType: window.localStorage.userType
      ? window.atob(window.localStorage.userType)
      : undefined,
    userEmail: window.localStorage.userEmail
      ? window.atob(window.localStorage.userEmail)
      : undefined,
    selectedCalendarType: CalendarTypes.DAY,
    selectedDate: null,
    selectedWeekStartDate: null,
    selectedMonthStartDate: null
  },
  mutations: {
    setUserInfo(state) {
      state.userName = window.localStorage.userName
        ? window.atob(window.localStorage.userName)
        : undefined;

      state.userType = window.localStorage.userType
        ? window.atob(window.localStorage.userType)
        : undefined;

      state.userType = window.localStorage.userType
        ? window.atob(window.localStorage.userType)
        : undefined;
    },
    setIsMobileNavOpen(state, isOpen) {
      state.isMobileNavOpen = isOpen;
    },
    setSelectedCalendarType(state, type) {
      state.selectedCalendarType = type;
    },
    setSelectedDate(state, date) {
      state.selectedDate = date;
    },
    setSelectedWeekStartDate(state, date) {
      state.selectedWeekStartDate = date;
    },
    setSelectedMonthStartDate(state, date) {
      state.selectedMonthStartDate = date;
    }
  },
  actions: {
    async getInitialFakeData({ dispatch }) {
      const crewsData = await dispatch("getFakeCrews");
      const crews = crewsData.crews;

      const customersData = await dispatch("getFakeCustomers");
      const customers = customersData.customers;

      const contractsData = await dispatch("getContracts");
      const contracts = contractsData.contracts;

      const projectsData = await dispatch("getProjects");
      const projects = projectsData.projects;

      return { crews, customers, contracts, projects };
    },
    handleApiResponse({ dispatch }, data) {
      if (data.responseStatus === ApiResponseStatus.SUCCESS) {
        if (data.successText) {
          dispatch("addSuccessToast", data.successText);
        }

        data.afterSuccessFunction();
      } else {
        dispatch("addErrorToast", data.errorText);
      }
    },
    getStartAndEndDates({ rootState }) {
      let startDate, endDate;

      switch (rootState.selectedCalendarType) {
        case CalendarTypes.DAY:
          startDate = rootState.selectedDate.format("YYYY-MM-DD");
          endDate = startDate;
          break;
        case CalendarTypes.WEEK:
          startDate = rootState.selectedWeekStartDate.format("YYYY-MM-DD");
          endDate = rootState.selectedWeekStartDate
            .clone()
            .endOf("week")
            .format("YYYY-MM-DD");
          break;
        case CalendarTypes.MONTH:
          startDate = rootState.selectedMonthStartDate.format("YYYY-MM-DD");
          endDate = rootState.selectedMonthStartDate
            .clone()
            .endOf("month")
            .format("YYYY-MM-DD");
          break;
        default:
          startDate = null;
          endDate = null;
          break;
      }

      return { startDate, endDate };
    }
  }
});
